import { Component } from '@angular/core';
import { ProductsConfigGet, ProductsConfigParams } from '../products-config/products-config.component';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-products-config-view',
    templateUrl: './products-config-view.component.html',
    styleUrls: ['./products-config-view.component.css'],
})
export class ProductsConfigViewComponent {
    public params: ProductsConfigParams;

    public heading = '';

    constructor(private state: StateService) {
        this.params = this.state.getStateParams() as unknown as ProductsConfigParams;
    }

    public setHeading(event: ProductsConfigGet) {
        this.heading = event.webpage_heading;
    }

    public onSubmit(event: ProductsConfigGet) {
        this.state.back(`${event.finish_item_state}/${event.finish_item_parms}`);
    }
}
